/* eslint-disable camelcase */
import {
  Entity, PrimaryGeneratedColumn, Column, OneToOne,
  JoinColumn, CreateDateColumn, UpdateDateColumn, ManyToOne,
} from 'typeorm';
import {
  IsOptional, IsBoolean, IsInt, IsDate, IsNumber, IsString,
} from 'class-validator';
import {
  TipoParto, RupturaBolsa, DuracaoPeriodoExpulsivo, SangramentoPosParto, PartoNaAgua,
  ManobraDequitacao, Clampeamento, Encaminhamento,
} from '../types';
import { Paciente } from './Paciente';
import { Gestacao } from './Gestacao';
import { Usuario } from './Usuario';

@Entity({ name: 'partos' })
export class Parto {
  @PrimaryGeneratedColumn()
  id?: number;

  @Column()
  @IsInt()
  paciente_id: number;

  @Column()
  @IsInt()
  gestacao_id: number;

  // PARTO
  @Column({
    type: 'enum',
    enum: TipoParto,
  })
  tipo_parto: TipoParto;

  @Column()
  @IsDate()
  @IsOptional()
  data_parto?: Date | null;

  @Column({
    type: 'enum',
    enum: RupturaBolsa,
  })
  @IsOptional()
  ruptura_bolsa?: RupturaBolsa | null;

  @Column({
    type: 'enum',
    enum: DuracaoPeriodoExpulsivo,
  })
  @IsOptional()
  duracao_periodo_expulsivo?: DuracaoPeriodoExpulsivo | null;

  @Column({
    type: 'enum',
    enum: SangramentoPosParto,
  })
  @IsOptional()
  sangramento_pos_parto?: SangramentoPosParto | null;

  @Column()
  @IsString()
  @IsOptional()
  observacoes?: string | null;

  // ABORTO
  @Column()
  @IsInt()
  @IsOptional()
  ig_aborto_semanas?: number | null;

  // PARTO NORMAL
  @Column({
    type: 'enum',
    enum: PartoNaAgua,
  })
  @IsOptional()
  parto_na_agua?: PartoNaAgua | null;

  // Tem enum com valores propostos. Pode ser outra string
  @Column()
  @IsOptional()
  posicao_parto?: string | null;

  @Column()
  @IsInt()
  @IsOptional()
  tempo_dequitacao?: number | null;

  @Column({
    type: 'enum',
    enum: ManobraDequitacao,
  })
  @IsOptional()
  manobra_dequitacao?: ManobraDequitacao | null;

  @Column()
  @IsInt()
  @IsOptional()
  laceracao?: number | null;

  @Column()
  @IsOptional()
  sutura?: boolean | null;

  // CESAREA
  // Tem enum com valores propostos. Pode ser outra string
  @Column()
  @IsOptional()
  indicacao_cesarea?: string | null;

  // OCORRENCIAS
  @Column()
  @IsBoolean()
  @IsOptional()
  ocorrencia_hpp?: boolean | null;

  // Tem enum com valores propostos. Pode ser outra string
  @Column()
  @IsOptional()
  hpp_quantidade?: string | null;

  @Column()
  @IsBoolean()
  @IsOptional()
  ocorrencia_induzido?: boolean | null;

  @Column()
  @IsBoolean()
  @IsOptional()
  ocorrencia_analgesia?: boolean | null;

  @Column()
  @IsBoolean()
  @IsOptional()
  ocorrencia_vacuo?: boolean | null;

  @Column()
  @IsBoolean()
  @IsOptional()
  ocorrencia_forceps?: boolean | null;

  @Column()
  @IsBoolean()
  @IsOptional()
  ocorrencia_ruptura?: boolean | null;

  @Column()
  @IsBoolean()
  @IsOptional()
  ocorrencia_ocitocina?: boolean | null;

  @Column()
  @IsBoolean()
  @IsOptional()
  ocorrencia_episiotomia?: boolean | null;

  @Column()
  @IsBoolean()
  @IsOptional()
  ocorrencia_kristeller_pressao_fundica?: boolean | null;

  @Column()
  @IsBoolean()
  @IsOptional()
  ocorrencia_uti_materna?: boolean | null;

  @Column()
  @IsBoolean()
  @IsOptional()
  ocorrencia_transfusao?: boolean | null;

  @Column()
  @IsBoolean()
  @IsOptional()
  ocorrencia_distocia_ombros?: boolean | null;

  // BEBE 1
  @Column()
  @IsNumber()
  @IsOptional()
  peso1_gramas: number | null;

  @Column()
  @IsNumber()
  @IsOptional()
  apgar1_1: number | null;

  @Column()
  @IsNumber()
  @IsOptional()
  apgar1_2: number | null;

  @Column()
  @IsNumber()
  @IsOptional()
  apgar1_3?: number | null;

  @Column({
    type: 'enum',
    enum: Clampeamento,
  })
  @IsOptional()
  clampeamento1?: Clampeamento | null;

  @Column()
  @IsBoolean()
  @IsOptional()
  contato_pele1?: boolean | null;

  @Column()
  @IsOptional()
  contato_pele1_justificativa?: string | null;

  // Tem enum com valores propostos. Pode ser outra string
  @Column()
  @IsOptional()
  amamentacao1?: string | null;

  @Column({
    type: 'enum',
    enum: Encaminhamento,
  })
  @IsOptional()
  encaminhamento1?: Encaminhamento | null;

  @Column()
  @IsOptional()
  encaminhamento1_justificativa?: string | null;

  @Column()
  @IsOptional()
  intercorrencias1?: string | null;

  // BEBE 2
  @Column()
  @IsNumber()
  @IsOptional()
  peso2_gramas?: number | null;

  @Column()
  @IsNumber()
  @IsOptional()
  apgar2_1?: number | null;

  @Column()
  @IsNumber()
  @IsOptional()
  apgar2_2?: number | null;

  @Column()
  @IsNumber()
  @IsOptional()
  apgar2_3?: number | null;

  @Column({
    type: 'enum',
    enum: Clampeamento,
  })
  clampeamento2?: Clampeamento | null;

  @Column()
  @IsBoolean()
  @IsOptional()
  contato_pele2?: boolean | null;

  @Column()
  @IsOptional()
  contato_pele2_justificativa?: string | null;

  // Tem enum com valores propostos. Pode ser outra string
  @Column()
  @IsOptional()
  amamentacao2?: string | null;

  @Column({
    type: 'enum',
    enum: Encaminhamento,
  })
  @IsOptional()
  encaminhamento2?: Encaminhamento | null;

  @Column()
  @IsOptional()
  encaminhamento2_justificativa?: string | null;

  @Column()
  @IsOptional()
  intercorrencias2?: string | null;

  @CreateDateColumn()
  created?: Date;

  @Column()
  @IsOptional()
  created_by?: number | null;

  @UpdateDateColumn()
  updated?: Date;

  @Column()
  @IsOptional()
  updated_by?: number | null;

  // RELATIONS
  @OneToOne(() => Paciente)
  @JoinColumn({ name: 'paciente_id' })
  paciente?: Paciente;

  @OneToOne(() => Gestacao)
  @JoinColumn({ name: 'gestacao_id' })
  gestacao?: Gestacao;

  @ManyToOne(() => Usuario)
  @JoinColumn({ name: 'created_by' })
  usuario_created_by?: Usuario;

  @ManyToOne(() => Usuario)
  @JoinColumn({ name: 'updated_by' })
  usuario_updated_by?: Usuario;
}
